import type { Client, RequestContext } from "../client";
import type {
    GetOpenTelemetryTraceFileExportConfigurationResponse,
    GetOpenTelemetryTraceFilesMetadataBffResponse,
    ModifyOpenTelemetryTraceFileExportConfigurationCommand,
    ModifyOpenTelemetryTraceFileExportConfigurationResponse,
} from "../resources/openTelemetryTraceFileExportConfigurationResource";

export class OpenTelemetryTraceFileExportConfigurationRepository {
    constructor(
        private readonly client: Client,
        private readonly requestContext: RequestContext
    ) {
        this.client = client;
    }

    get(): Promise<GetOpenTelemetryTraceFileExportConfigurationResponse> {
        return this.client.get(this.requestContext, `~/api/configuration/open-telemetry-trace-file-export`);
    }

    getMetadata(): Promise<GetOpenTelemetryTraceFilesMetadataBffResponse> {
        return this.client.get(this.requestContext, `~/bff/open-telemetry-trace-file-export/metadata`);
    }

    modify(model: ModifyOpenTelemetryTraceFileExportConfigurationCommand): Promise<ModifyOpenTelemetryTraceFileExportConfigurationResponse> {
        return this.client.put(this.requestContext, `~/api/configuration/open-telemetry-trace-file-export`, model);
    }

    deleteAllTraceFiles(): Promise<unknown> {
        return this.client.delete(this.requestContext, `~/bff/open-telemetry-trace-file-export/files`);
    }
}
